import type { LineItem, Product } from '@commerce/types'
import { getIdFromGraphQlId } from '@lib/general'
import { eventLog, EVENT_DEBUG, infoLog, loginStatus } from './general'

declare global {
  interface Window {
    dataLayer: any
  }
}

export const addToCartEvent = (
  product: Product.Product,
  variant: any,
  quantity: number
) => {
  if (EVENT_DEBUG && !window?.dataLayer) {
    infoLog('Add To Cart: No Data Layer found.')
  }

  if (window?.dataLayer) {
    const detail = {
      event: 'addToCart',
      ecommerceEventLabel: 1,
      google_tag_params: {
        ecomm_pagetype: 'cart',
        ecomm_prodid: getIdFromGraphQlId(product?.id, 'gid://shopify/Product/'),
        ecomm_category: product?.vendor,
        ecomm_totalvalue: Number(product?.price?.value),
      },
      ecommerce: {
        currencyCode: product?.price?.currencyCode,
        add: {
          products: [
            {
              name: product?.name,
              brand: product?.vendor,
              id: getIdFromGraphQlId(product?.id, 'gid://shopify/Product/'),
              price: Number(product?.price?.value),
              variant: variant?.name,
              quantity,
            },
          ],
        },
      },
      ...loginStatus(),
    }
    window?.dataLayer?.push(detail)
    if (EVENT_DEBUG)
      eventLog(`Add To Cart 'gtm.ecommerce.AddToCart (custom)`, { detail })
  }
}

export const addFromCart = (product: LineItem.Lineitem, quantity: number) => {
  if (EVENT_DEBUG && !window?.dataLayer) {
    infoLog('Add from Cart: No Data Layer found.')
  }
  if (window?.dataLayer) {
    const detail = {
      event: 'ecommerce',
      ecommerceEvent: 'addToCart',
      ecommerceEventLabel: 1,
      google_tag_params: {
        ecomm_pagetype: 'cart',
        ecomm_prodid: getIdFromGraphQlId(
          product?.productId,
          'gid://shopify/Product/'
        ),
        ecomm_category: product?.vendor,
        ecomm_totalvalue: product?.variant?.price,
      },
      ecommerce: {
        currencyCode: 'AUD',
        add: {
          products: [
            {
              name: product?.name,
              category: product?.vendor,
              id: getIdFromGraphQlId(
                product?.productId,
                'gid://shopify/Product/'
              ),
              price: product?.variant?.price,
              variant: product?.variant?.name,
              quantity: quantity,
            },
          ],
        },
      },
      ...loginStatus(),
    }
    window?.dataLayer?.push(detail)
    if (EVENT_DEBUG)
      eventLog(`Add from Cart 'gtm.ecommerce.AddToCart (custom)`, {
        detail,
      })
  }
}
